import { GroupElementGrid } from '@ferreri/prever-component-lib';
import { PLAN_BENEFITS } from './planBenefits';
import { PlanBenefitsCardInfoListItem } from './PlanBenefitsCardInfoListItem';

export const PlanBenefitsList = () => {
  return (
    <GroupElementGrid>
      {PLAN_BENEFITS.map((benefits) => (
        <PlanBenefitsCardInfoListItem key={benefits.uri} benefits={benefits} />
      ))}
    </GroupElementGrid>
  );
};
